// #region Imports
//Components
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-checkbox-field',
    mixins: [appHost.mixins.form],
    // #endregion
    // #region Components
    components: {
        DxCheckBox: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon" */ /* webpackMode: "lazy" */ 'devextreme-vue/check-box')).DxCheckBox;
        }),
    },
    // #endregion
    // #region Props
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    // #endregion
});
// #endregion
